import { render, staticRenderFns } from "./ImagePicker.vue?vue&type=template&id=1157a2c4&scoped=true&"
import script from "./ImagePicker.vue?vue&type=script&lang=js&"
export * from "./ImagePicker.vue?vue&type=script&lang=js&"
import style0 from "./ImagePicker.vue?vue&type=style&index=0&id=1157a2c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1157a2c4",
  null
  
)

export default component.exports